import React from 'react';
import { LG } from '@zendeskgarden/react-typography';
import { PropTypes } from 'prop-types';

const statusMap = {
  deleted: {
    title: 'This Listing No Longer Exisits',
  },
};

function ProductsStatusMessage({ status }) {
  const details = statusMap[status];
  return (
    <div style={{ maxWidth: '700px', margin: '0 auto' }}>
      {details ? (
        <div>
          <LG grey center paddingTopLg>
            {details.title}
          </LG>
        </div>
      ) : (
        <LG grey center paddingTopLg>
          This Listing is currently {status}
        </LG>
      )}
    </div>
  );
}

ProductsStatusMessage.propTypes = {
  status: PropTypes.string,
};

export default ProductsStatusMessage;
